import { render, staticRenderFns } from "./InspectionInputImage.vue?vue&type=template&id=0844a290&scoped=true&"
import script from "./InspectionInputImage.vue?vue&type=script&lang=ts&"
export * from "./InspectionInputImage.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionInputImage.vue?vue&type=style&index=0&id=0844a290&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0844a290",
  null
  
)

export default component.exports